/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RecipeDeleteModalMutationVariables = {|
  id: string
|};
export type RecipeDeleteModalMutationResponse = {|
  +recipeDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type RecipeDeleteModalMutation = {|
  variables: RecipeDeleteModalMutationVariables,
  response: RecipeDeleteModalMutationResponse,
|};
*/


/*
mutation RecipeDeleteModalMutation(
  $id: ID!
) {
  recipeDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeDeletePayload",
    "kind": "LinkedField",
    "name": "recipeDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecipeDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecipeDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "RecipeDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation RecipeDeleteModalMutation(\n  $id: ID!\n) {\n  recipeDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e41ee11da4656af46a7fe02cc2b7dc04';

module.exports = node;
